import { render } from "./ViewJobVacancy.vue?vue&type=template&id=3c60b9fd&scoped=true"
import script from "./ViewJobVacancy.vue?vue&type=script&lang=js"
export * from "./ViewJobVacancy.vue?vue&type=script&lang=js"

import "./vacancy.scss?vue&type=style&index=0&id=3c60b9fd&lang=scss&scoped=true"

import exportComponent from "/Users/mapat/Projects/orange-hrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c60b9fd"]])

export default __exports__